import { gql } from "@apollo/client";

export const WORK_ORDERS_QUERY = gql`query Workorders {
  workorders {
      createdAt
      createdById
      deletedAt
      deletedById
      description
      endTime
      id
      key
      locationId
      parentId
      pocUserIds
      serviceCategoryId
      severity
      startTime
      timezone
      title
      updatedAt
      updatedById
      workOrderStageId
      workOrderTypeId
      assetWorkOrders {
          assetId
          comment
          createdAt
          deletedAt
          id
          serviceTypeId
          subLocationId
          updatedAt
          workOrderId
          assetPlans {
              assetWorkOrderId
              comment
              createdAt
              deletedAt
              description
              id
              itemId
              name
              planId
              sublocation
              type
              updatedAt
          }
      }
      workOrderStage {
          color
          createdAt
          deletedAt
          id
          isDefault
          name
          updatedAt
      }
      location {
          address1
          address2
          city
          coordinates
          countryAlpha2
          createdAt
          deletedAt
          description
          fileId
          id
          name
          parentId
          state
          sublocation
          type
          updatedAt
          zip
          assets {
              assetTypeId
              config
              createdAt
              createdById
              deletedAt
              deletedById
              description
              fileIds
              id
              locationId
              maintenanceIds
              manufacturerId
              name
              position
              status
              updatedAt
              updatedById
              userIds
              vendorId
              assetFieldValues {
                  assetFieldId
                  assetId
                  createdAt
                  deletedAt
                  id
                  updatedAt
                  value
                  assetField {
                      assetTypeId
                      createdAt
                      deletedAt
                      description
                      id
                      label
                      order
                      required
                      selectOptions
                      type
                      unit
                      updatedAt
                  }
              }
              assetMaintenanceSchedules {
                  assetId
                  createdAt
                  deletedAt
                  description
                  endTime
                  id
                  intervalType
                  intervalValue
                  name
                  remindBeforeType
                  remindBeforeValue
                  startTime
                  timezone
                  updatedAt
              }

              assetUsers {
                  assetId
                  createdAt
                  deletedAt
                  id
                  updatedAt
                  userId
              }
              location {
                  address1
                  address2
                  city
                  coordinates
                  countryAlpha2
                  createdAt
                  deletedAt
                  description
                  fileId
                  id
                  name
                  parentId
                  state
                  sublocation
                  type
                  updatedAt
                  zip
                  file {
                      belongsToId
                      belongsToType
                      createdAt
                      deletedAt
                      description
                      fileSize
                      folderId
                      id
                      name
                      path
                      type
                      updatedAt
                  }
              }
          }
          file {
              belongsToId
              belongsToType
              createdAt
              deletedAt
              description
              fileSize
              folderId
              id
              name
              path
              type
              updatedAt
          }
      }
  }
}

`;

// ==================== ==================== Master Data Mutations ==================== ==================== 
// Manufacturers Query
